import React from "react";
import styles from "./AnswerTab.module.scss";
export const AnswerTab = ({ value, active, onClick }) => {
  return (
    <div
      className={`${styles.answerTab} ${active ? styles.active : ""}`}
      onClick={onClick}
    >
      <p className={styles.answer}>{value}</p>
    </div>
  );
};
